export default {
  test: "fr test",
  topbar: {
    ownerTitle: "Gérant?",
    addMyPlace: "Ajouter mon établissement",
    loginSignup: "Me connecter/M'enregistrer",
    myPlaces: "Mes établissements",
    myAccount: "Mon compte",
    logout: "Déconnexion",
    welcome: "Bienvenue { username }",
    whyJoinLabel: "Pourquoi rejoindre Maïka ?",
    whyJoinURL: "https://maika.coffee/fr/why-join-network.html",
    tryAppLabel: "Essayer l'App !",
  },
  login: {
    onlyOnwer: "** Espace réservé aux propriétaires d'établissements **",
    backToMaika: "Retourner sur Maïka",
    email: "Adresse mail",
    password: "Mot de passe",
    login: "Me connecter",
    forgotPassword: "J'ai oublié mon mot de passe",
    newToApp: "Nouveau chez Maïka ?",
    signup: "Me créer un compte !",
    passwordShort: "Le mot de passe doit faire au moins 8 caractères",
    fieldsMandatory: "Tous les champs sont requis",
  },
  signup: {
    onlyOnwer: "** Espace réservé aux propriétaires d'établissements **",
    backToMaika: "Retourner sur Maïka",
    signup: "Création de compte",
    email: "Adresse mail",
    password: "Mot de passe",
    login: "Me connecter",
    agreeTo: "J'accepte",
    conditions: " les conditions d'utilisation",
    and: " et ",
    privacy: "la politique de confidentialité",
    alreadyRegistred: "Vous avez déjà un compte Maïka ?",
    passwordShort: "Le mot de passe doit faire au moins 8 caractères",
    accountCreated:
      "Votre compte a bien été créé ! Vous allez recevoir un mail pour terminer l'inscription.",
    fieldsMandatory: "Tous les champs sont requis",
  },
  home: {
    myPlacesTitle: "Mes établissements",
    addPlaceBtn: "Ajouter un établissement",
    pendingVerification:
      "Un mail a été envoyé. Veuillez cliquer sur le lien qu'il contient pour terminer votre inscription",
  },
  placeRow: {
    verifiedLabel: "Vérifié !",
    notVerifiedLabel:
      "Non vérifié - Faites vérifiez votre établissement pour le rendre plus visible auprès de { users } personnes",
    beingReviewed:
      "Établissement en cours de vérification. Vous recevrez un mail dès qu'il sera vérifié",
    wasStopped:
      "Vous avez annulé l'abonnement. Allez dans la page de détails du lieu pour le réactiver",
    nextPaymentDate: "Prochain paiement dû au { paymentDate }",
    openDetailsBtn: "Voir les détails",
    pdfBtn: "Télécharger la dernière facture",
    seeDetailsLink: "Voir les détails de l'établissement",
    verifyBtn: "Faire vérifier l'établissement",
  },
  placeDetail: {
    stopRenew: "Arrêter le renouvellement",
    backToPlaces: "Retour",
    verification: {
      title: "Vérification de l'établissement",
      howLink: "Comment vérifier mon établissement améliorera mon commerce ?",
      documentNeededTitle:
        "Dans le but de vérifier votre établissement, vous aurez besoin de :",
      documentNeededOne:
        "• Un document prouvant que vous êtes bien le gérant de cet établissement",
      documentNeededTwo:
        "• Un document prouvant que votre établissement possède une connexion WiFi (une facture de votre fournisseur par exemple)",
      plans: {
        planTitle: "Choissisez le plan désiré",
        monthlyTitle: "Plan mensuel",
        yearlyTitle: "Plan annuel",
        monthLabel: "mois",
        yearLabel: "an",
        selectButton: "Sélectionner cette option",
        monthlyDescription: {
          first: "• Affiché en tant qu'établissement vérifié",
          second: "• Être plus visible auprès de { users } télétravailleurs",
          third: "• Avoir un accès privilégié aux prochaines fonctionnalités",
          fourth: "• Faire partie du réseau Maïka",
        },
        yearlyDescription: {
          first: "• Tous les avantages du plan mensuel",
          second: "• Avec deux mois gratuits",
          third: "",
        },
      },
      documents: {
        title: "Téléchargez vos documents",
        docIdentity: "Document prouvant que vous êtes le gérant",
        docWifi: "Document prouvant que vous mettez à disposition du WiFi",
        errors: {
          fileTooBig: "La taille du fichier ne peut pas excéder 3MB",
          wrongFileType: "Le fichier doit être un pdf ou une image",
        },
      },
      form: {
        title: "Informations",
        furtherInformationLabel: "Une information à ajouter ?",
        vatNumberLabel: "Numéro de TVA",
      },
      payment: {
        title: "Procéder au paiement",
        furtherInformationLabel: "Une information à ajouter ?",
        vatNumberLabel: "Numéro de TVA",
        paymentBtn: "Procéder au paiement",
        secureLabel: "Paiement sécurisé par Stripe",
        incompleteForm:
          "Veuillez sélectionner un plan et télécharger les documents requis",
      },
    },
  },
  paymentSuccess: {
    firstSentence: "Merci pour votre paiement !",
    secondSentence:
      "Vous recevrez un mail dès que vos documents seront vérifiés !",
    goBackBtn: "Retourner à l'accueil",
  },
  accountVerification: {
    endMessage:
      "Pour finir votre inscription, veuillez remplir les informations suivantes",
    form: {
      firstname: "Prénom",
      lastname: "Nom de famille",
      address: "Adresse professionnelle",
      sendForm: "Envoyer",
      successMessage:
        "Votre compte a été vérifié ! Vous allez être automatique connecté.",
    },
  },
  accountDetail: {
    hello: "Bonjour",
    backToHome: "Retour à l'accueil",
    fetchError: "Une erreur s'est produite. veuillez réessayer ultérieurement",
    manageSubBtn: "Gérer mes abonnements",
    showInvoicesBtn: "Voir mes factures",
    contactBtn: "Nous contacter",
    invoiceNumber: "Facture N°",
    seeInvoiceDetails: "Aller à la facture",
    paidOn: "Payé le",
  },
  verifiedPlace: {
    manageSubscription: "Gérer mes abonnements",
    monthlyPlanLabel: "Plan mensuel",
    yearlyPlanLabel: "Plan annuel",
    nextRenew: "Prochain paiement prévu le : ",
    wasStopped:
      "Vous avez arrêté votre abonnement. Vous pouvez le réactiver en cliquant sur 'Gérer mes abonnements'",
    price: "prix : ",
  },
  addPlace: {
    title: "Ajouter votre établissement",
    searchLabel: "Cherchez ici ou cliquez sur la carte",
    searchButton: "Rechercher",
    confirmPlace: "Je gère cet établissement",
    confirmPlaceAlert:
      "Un document prouvant que vous êtes le gérant pourra vous être demandé à tout moment",
    alreadyAddedAlert:
      "Cet établissement a déjà été ajouté. Si c'est le vôtre, veuillez ",
    contactUs: "nous contacter",
    addedSuccess: "Établissement ajouté avec succès ! Vous pouvez retourner à",
    addedSuccessLink: "votre page d'accueil",
    addButton: "Ajouter cet établissement",
  },
  errors: {
    general: {
      generalError: "Une erreur s'est produite",
    },
    login: {
      incorrectPwd: "Mot de passe incorrect",
      notExists: "Adresse mail incorrecte ou compte inexistant.",
    },
    signup: {
      alreadyRegistred: "Cette adresse email est déjà enregistrée.",
    },
    accountVerification: {
      formIncomplete: "Tous les champs avec un '*' sont obligatoires",
    },
  },
};
